import { useTranslation } from 'react-i18next'
import { Col, Row } from 'antd'

import { useAppSelector } from '@/store/hook'
import { selectHasSessionBasedShoppingCart } from 'store/selectors/userSelector'
import { isValidArray } from '@/libs/utils/array'

const getUserName = (username) => {
  return isValidArray(username) ? username[1] : username
}

const InformationBlock = ({
  partnerNumber = '',
  username = '',
  email = '',
}) => {
  const isTechnicalUser = useAppSelector(selectHasSessionBasedShoppingCart)

  const { t } = useTranslation()
  return (
    <div className="profile__head">
      <div className="profile__head__background" />
      <div className="profile__head__wrapper">
        <h1 className="profile__title">{t('myProfile.title')}</h1>
        <Row gutter={[12, 24]}>
          <Col sm={7} xl={8} xs={8}>
            <p className="profile__head__title mb-0">
              {t('myProfile.header.title')}
            </p>
            <p className="profile__head__value">{partnerNumber || 'N/A'}</p>
          </Col>
          {!isTechnicalUser && (
            <Col xs={8} sm={7} xl={8}>
              <p className="profile__head__title mb-0">
                {t('myProfile.header.userName')}
              </p>
              <p className="profile__head__value">{getUserName(username)}</p>
            </Col>
          )}
          <Col xs={8} sm={7} xl={8}>
            <p className="profile__head__title mb-0">
              {t('myProfile.header.emailAddress')}
            </p>
            <p className="profile__head__value">{getUserName(email)}</p>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default InformationBlock
